import { InsurersAndPackagesService } from '@/api/HomelabService'

export const actions = {

  INITIALIZE_MODULE ({ dispatch }) {
    dispatch('LOAD_INSURERS')
    dispatch('LOAD_PACKAGES')
  },

  LOAD_INSURERS ({ commit, state }) {
    if (state.insurers === null) {
      InsurersAndPackagesService.getInsurers()
        .then(insurers => commit('SET_INSURERS', { insurers }))
        .catch(errors => {
          console.log(errors)
          commit('SET_INSURERS', { insurers: [] })
        })
    }
  },
  LOAD_PACKAGES ({ commit, state }) {
    if (state.packages === null) {
      InsurersAndPackagesService.getPackages()
        .then(packages => commit('SET_PACKAGES', { packages }))
        .catch(errors => {
          console.log(errors)
          commit('SET_PACKAGES', { packages: [] })
        })
    }
  }
}
